import classNames from 'classnames/bind';
import React, { useMemo } from 'react';

import styles from './common.module.scss';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  const message = useMemo(() => {
    switch (command.data.enable) {
      case 0:
        return 'Disable autotune.';
      case 1:
        return 'Enable autotune.';
      default:
        return;
    }
  }, [command.data.enable]);

  return (
    <div className={cx('container')}>
      <div className={cx('message')}>{message}</div>
    </div>
  );
};

export default Item;
